import React from 'react';
import PropTypes from 'prop-types';

const Dashboard2Icon = ({ className = '' }) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
    data-icon-variant="stroke"
  >
    <rect
      x="4"
      y="4"
      width="16"
      height="16"
      rx="2"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="4"
      y1="9"
      x2="20"
      y2="9"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <line
      x1="9"
      y1="10"
      x2="9"
      y2="20"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);

Dashboard2Icon.propTypes = {
  className: PropTypes.string,
};

export default Dashboard2Icon;
